import { BUList } from "../user/userTypes"


export interface SupportArticlesState {
    articles: Article[]
}

export interface Article {
    _id: string
    title: string
    description: string
    section: ArticleSection
    created_at: Date
    updated_at: Date
    link: string
    BUList?: BUList[] // Necessary to create an article but not needeed to display it
    image: string
}

export enum ArticleSection {
    FIRST_STEPS = 'firstSteps',
    USECASES = 'useCases',
}